<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-s-promotion"
      @click="openSendMailDialog()"
      >发送邮件</el-button
    >
    <el-tabs v-model="tabValue">
      <el-tab-pane label="邮件模板" name="mailTemplate">
        <MailTemplateList v-if="tabValue == 'mailTemplate'"></MailTemplateList>
      </el-tab-pane>
      <el-tab-pane label="附件模板" name="propsTemplate">
        <PropsTemplateList
          v-if="tabValue == 'propsTemplate'"
        ></PropsTemplateList>
      </el-tab-pane>
      <el-tab-pane label="定时邮件" name="scheduledMail">
        <ScheduledMail v-if="tabValue == 'scheduledMail'"></ScheduledMail>
      </el-tab-pane>
      <el-tab-pane label="历史发送邮件" name="historySentMails">
        <HistorySentMails
          v-if="tabValue == 'historySentMails'"
        ></HistorySentMails>
      </el-tab-pane>
    </el-tabs>
    <!-- “添加邮件模板”对话框 -->
    <EditMailTemplateDialog
      v-if="shouldEditTemplateDialogVisible"
      @close="onEditMailTemplateDialogClosed()"
      :value="valueForEditMailTemplateDialog"
    ></EditMailTemplateDialog>

    <!-- “发送邮件”对话框 -->
    <SendMailDialog
      v-if="shouldSendMailDialogVisible"
      @close="onSendMailDialogClosed()"
      :value="dataForSendMailDialog"
    >
    </SendMailDialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import EditMailTemplateDialog from "./EditMailTemplateDialog";
import SendMailDialog from "./SendMailDialog";
import MailTemplateList from "./tab-pages/MailTemplateList";
import PropsTemplateList from "./tab-pages/PropsTemplateList";
import ScheduledMail from "./tab-pages/ScheduledMail";
import HistorySentMails from "./tab-pages/HistorySentMails";

export default {
  data() {
    return {
      tabValue: "mailTemplate",
      shouldEditTemplateDialogVisible: false, // “添加邮件模板”对话框是否应该显示出来
      shouldSendMailDialogVisible: false, // “发送邮件”对话框是否应该显示出来
      valueForEditMailTemplateDialog: null, // 要传递给“添加邮件模板”对话框的数据
      mailTemplateTableData: [], // 邮件模板列表里展示的数据
      dataForSendMailDialog: null, // 要传递给“发送邮件”对话框的数据
      languages: [], // 所有的语言
    };
  },

  components: {
    EditMailTemplateDialog,
    SendMailDialog,
    MailTemplateList,
    ScheduledMail,
    HistorySentMails,
    PropsTemplateList,
  },

  async created() {
    // 查询语言集合
    this.languages = await bizutil.loadAvailableLanguages();

    // 拉取邮件模板集合
    await this.loadMailTemplateList();
  },

  methods: {
    /**
     * 查询邮件模板集合
     */
    async loadMailTemplateList() {
      // 清空表格数据
      this.mailTemplateTableData = [];

      // 向服务器查询模板集合
      let resData = (
        await axios.get(
          `${util.getBackendApiBase()}/v1/admin/getMailTemplateList`,
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let mailTemplateListInResponse = resData.data.mailTemplateList || [];

      for (let mailTemplateInResponse of mailTemplateListInResponse) {
        let languageTemplates = [];

        for (let language of this.languages) {
          let title = "";
          let content = "";

          for (let languageTemplateInResponse of mailTemplateInResponse.mailTemplate) {
            if (languageTemplateInResponse.language == language) {
              title = languageTemplateInResponse.title;
              content = languageTemplateInResponse.content;
              break;
            }
          }

          languageTemplates.push({
            language: language,
            title: title,
            content: content,
          });
        }

        this.mailTemplateTableData.push({
          mailTemplateId: mailTemplateInResponse.mailTemplateId,
          mailTemplateName: mailTemplateInResponse.mailTemplateName,
          languageTemplates: languageTemplates,
          activeLanguageTabName: this.languages[0],
        });
      }

      // 排序（按模板被创建的顺序倒序排列）
      this.mailTemplateTableData.sort((x, y) => {
        return Number(y.mailTemplateId) - Number(x.mailTemplateId);
      });
    },

    /**
     * 打开“添加邮件模板”对话框
     */
    async openEditMailTemplateDialog(isCreate, templateData) {
      this.shouldEditTemplateDialogVisible = true;
      this.valueForEditMailTemplateDialog = {
        isCreate: isCreate,
        templateData: templateData,
      };
    },

    /**
     * “添加邮件模板”对话框关闭了
     */
    async onEditMailTemplateDialogClosed() {
      this.shouldEditTemplateDialogVisible = false;

      // 重新拉取邮件模板集合
      return this.loadMailTemplateList();
    },

    /**
     * 打开“发送邮件”对话框
     */
    async openSendMailDialog(templateData) {
      this.shouldSendMailDialogVisible = true;
      this.dataForSendMailDialog = {
        mailTemplate: templateData,
      };
    },

    /**
     * “发送邮件”对话框关闭了
     */
    async onSendMailDialogClosed() {
      this.shouldSendMailDialogVisible = false;
    },
  },
};
</script>